export default "__VITE_ASSET__d6WdukXJ__"